import React from "react";
import { useDispatch } from "react-redux";
import { modifyPost } from "../../features/post/postSlice";

const Post = ({ post }) => {
  const { id, title, description, likes, tags, image, isSaved } = post || {};

  const dispatch = useDispatch();
  const handleSave = () => {
    dispatch(modifyPost({ id, data: { isSaved: !isSaved } }));
  };

  const handleLike = () => {
    dispatch(modifyPost({ id, data: { likes: likes + 1 } }));
  };

  return (
    <main className="post">
      <img
        src={image}
        alt={title}
        className="w-full rounded-md"
        id="lws-megaThumb"
      />
      <div>
        <h1 className="mt-6 text-2xl post-title" id="lws-singleTitle">
          {title}
        </h1>
        <div className="tags" id="lws-singleTags">
          {tags?.map((tag) => {
            return <span key={tag}>#{tag},</span>;
          })}
        </div>
        <div className="btn-group">
          {/* <!-- handle like on button click --> */}
          <button
            onClick={handleLike}
            className="like-btn"
            id="lws-singleLinks"
          >
            <i className="fa-regular fa-thumbs-up"></i> {likes}
          </button>
          {/* <!-- handle save on button click --> */}
          {/* <!-- use ".active" class and "Saved" text  if a post is saved, other wise "Save" --> */}
          <button
            onClick={handleSave}
            className={`save-btn ${isSaved && "active"}`}
            id="lws-singleSavedBtn"
          >
            <i className="fa-regular fa-bookmark"></i>{" "}
            {isSaved ? "Saved" : "Save"}
          </button>
        </div>
        <div className="mt-6">
          <p>{description}</p>
        </div>
      </div>
    </main>
  );
};

export default Post;
